import * as types from '../actiontypes';
import Env from '../../util/env';
import {serviceURL, projectRoutes} from '../../util/uiconstants';

export function addContactToEntityProject(projectId, entityId, body) {
	return {
		type: types.ADD_CONTACTS_PROJECT_ENTITY,
		meta: {
			api: {
				url: getProjectUrl(projectId, entityId),
				data: body,
				method: 'POST'
			}
		}
	};
}

export function updateContactCustomColumns(projectId, obj) {	
	return {
		type: types.UPDATE_CONTACTS_CUSTOM_COL_ATTRIBUTE,
		meta: {
			api: {
				url: `${Env.getBaseURL(serviceURL)}Projects/${projectId}/Entities/${obj.entityId}/ContactProperties`,
				method: 'PUT',
				data: obj.data
			}
		},
		projectId
	};
}

const getProjectUrl = (projectId, entityId) => `${Env.getBaseURL(serviceURL)}Projects/${projectId}/Entity/${entityId}`;
